import "./Coalition.module.css";
import Header from "@/reusable_sections/Header";
import CoreOfferings from "./sections/CoreOfferings";
import Footer from "@/reusable_sections/Footer";
export default function CoalitionPage() {
  return <div>
      <Header />
      <CoreOfferings />
      <Footer />
    </div>;
}